module.exports = __webpack_public_path__ + "img/dtg.ff8f6d35.jpg";